$(document).ready(function () {
    $(document).on('click', '.js__add_cart', function () {
        const id = $(this).attr('data-id');
        let guid = $(this).attr('data-guid');
        let itemType = $(this).attr('data-item_type');
        const quantity = $(this)
            .closest('.js__quantity_block').find('.js__count_input')
            .val();
        const indexGtm = $(this).attr('data-indexGtm');
        const itemListNameGtm = $(this).attr('data-itemListNameGtm');
        let type_price = "";

        if ($(this).closest('.good_price_block').find('.js_input_price').length > 0) {
            type_price = $(this).closest('.good_price_block').find('.js_input_price .input_radio:checked').val();
        } else if ($(this).closest('.good_price_block').find('.new_prise').length > 0) {
            type_price = $(this).closest('.good_price_block').find('.new_prise').attr('data-price_type_id');
        }

        if (type_price == '') {
            type_price = $(this).attr('data-price_type_id');
        }

        if (typeof itemType !== typeof undefined && itemType !== false) {
            itemType = itemType;
        } else {
            itemType = "";
        }

        let object = {
            "id": id,
            "guid": guid,
            "itemType": itemType,
            "quantity": quantity,
            "indexGtm": indexGtm,
            "itemListNameGtm": itemListNameGtm,
            "type_price": type_price
        }

        if ($('.garanty_good').length > 0) {
            if ($('#garanty_good_price').is(':checked')) {
                let garanty = {
                    "id": id,
                    "guid": $('#garanty_good_price').attr('data-guid'),
                    "itemType": 'garanty_good',
                    "quantity": quantity,
                    "type_price": type_price,
                    "garanty_price": $('.garanty_good .js__show').attr('data-price'),
                }

                addGoodCart(garanty)
            }
        }

        addGoodCart(object)
    });


    $(document).on('click', '.js__garanty_cart', function () {
        const idGood = $(this).attr('data-id_good');
        const guidGood = $(this).attr('data-guid');
        var garantySpan = $(this).closest('.js__update_block_gtm').find('.js__info_garanty_gtm');

        let checkout = false;

        if ($(this).hasClass('gatanty_checkout')) {
            checkout = true;
        }

        const itemListNameGtm = $(`.js__add_cart[data-id=${idGood}]`).attr('data-itemlistnamegtm');
        if ($(this).is(':checked')) {
            const garantyPrice = $(this).closest('.garanty_good_cart').find('.js__show')
                .attr('data-price').split(' ').join('');
            const quantity = $(this).closest('.js__update_block_gtm')
                .find('.js__count_input').val();

            $.post(request.addGoodCart, {
                "id": idGood,
                "guid": guidGood,
                "item_type": "garanty_good",
                "cart_good_guids": toolsCartGoodsBuy.getGoods(),
                "quantity": quantity,
                "price_type_id": garantySpan.attr('data-price_type_id'),
                "garanty_price": garantyPrice,
                "lang": lang
            }, function (data) {
                if (data.status == 'ok') {
                    $(`#garanty_good_price_checkout_${guidGood}_${idGood}`).attr('checked', true);
                    $(`#garanty_good_price_${guidGood}_${idGood}`).attr('checked', true);

                    $('.js__all_active').attr('data-type_active', data.data.cart_quantity == data.data.cart_quantity_total ? 'all' : 'not_all');
                    $('.js__all_active .js__all_good_to_cart').empty().text(data.data.cart_quantity_total);
                    $('.js__all_active .js__all_good_active_to_cart').empty().text(data.data.cart_quantity);
                    $('.cart_header .total_info .count, .cart_model_checkout .total_info .count').text(data.data.cart_quantity);
                    $('.cart_header .total_info .price span, .cart_model_checkout .total_info .price span').text(data.data.cart_total);
                    $('.js__type_cart[data-type=modal]').find('.js__update_price').text(data.data.cart_total);
                    $('.js__quantity').text(data.data.cart_quantity);

                    if ($('.js__append_mini_cart').length > 0 && typeof data.data.html_mini_cart != 'undefined') {
                        $('.js__append_mini_cart').empty().append(data.data.html_mini_cart);
                    }

                    if ($('.js__main_page_info').length > 0) {
                        $('.js__main_page_info .main_page_user_tool_bar_text span').text(data.data.cart_total);
                    }

                    if (data.data.cart_total != 0 && Number(data.data.cart_total.split(' ').join('')) > 0) {
                        $('.cart_header .total_info .price').show();
                    }

                    if ($('.js__send_checkout').length > 0) {
                        $('.js__open_mini_cart span').empty().text(data.data.cart_quantity);
                        $('.js__update_quantity').empty().text(data.data.cart_quantity_text);
                        $('.js__update_total_sum').empty().text(data.data.cart_total);
                        $('.js__update_total_sum[data-total]').attr('data-total', data.data.cart_total.replace(/\s+/g, ''))

                        checkoutTools.updateTotalPrice();
                    }

                    if ($('.js__append_mini_cart').length > 0 && typeof data.data.html_mini_cart != 'undefined') {
                        $('.js__append_mini_cart').empty().append(data.data.html_mini_cart);
                    }

                    const dataGtm = [{
                        item_name: garantySpan.attr('data-itemName'),
                        item_id: garantySpan.attr('data-id'),
                        price: Number(garantySpan.attr('data-price').split(' ').join('')),
                        item_brand: null,
                        item_category: garantySpan.attr('data-cat3') != "" ? garantySpan.attr('data-cat3') : null,
                        item_category2: garantySpan.attr('data-cat2') != "" ? garantySpan.attr('data-cat2') : null,
                        item_category3: garantySpan.attr('data-cat1') != "" ? garantySpan.attr('data-cat1') : null,
                        item_category4: garantySpan.attr('data-cat4') != "" ? garantySpan.attr('data-cat4') : null,
                        item_variant: garantySpan.attr('data-itemVariant'),
                        item_list_name: itemListNameGtm,
                        index: '1',
                        quantity: Number(quantity),
                    }, { quantity: Number(quantity) }];
                    dataLayer.push({
                        ecommerce: null
                    });
                    dataLayer.push({
                        event: "add_to_cart",
                        label: "main",
                        ecommerce: {
                            items: [dataGtm[0]]
                        }
                    });
                    localStorage.setItem(`${garantySpan.attr('data-guidCart')}_${garantySpan.attr('data-id')}`, JSON.stringify(dataGtm));

                    // updateTotalSumForFondy(data);
                }
            })
        } else {
            $.post(request.removeCart, {
                "id_cart": guidGood,
                "id_good": idGood,
                "cart_good_guids": toolsCartGoodsBuy.getGoods(),
                "is_garanty": 1,
                "lang": lang
            }, function (data) {
                if (data.status == 'ok') {
                    $(`#garanty_good_price_checkout_${guidGood}_${idGood}`).attr('checked', false);
                    $(`#garanty_good_price_${guidGood}_${idGood}`).attr('checked', false);

                    $('.js__all_active').attr('data-type_active', data.data.cart_quantity == data.data.cart_quantity_total ? 'all' : 'not_all');
                    $('.js__all_active .js__all_good_to_cart').empty().text(data.data.cart_quantity_total);
                    $('.js__all_active .js__all_good_active_to_cart').empty().text(data.data.cart_quantity);

                    $('.cart_header .total_info .count, .cart_model_checkout .total_info .count').text(data.data.cart_quantity);
                    $('.cart_header .total_info .price span, .cart_model_checkout .total_info .price span').text(data.data.cart_total);
                    $('.js__type_cart[data-type=modal]').find('.js__update_price').text(data.data.cart_total);
                    $('.js__quantity').text(data.data.cart_quantity);

                    if ($('.js__main_page_info').length > 0) {
                        $('.js__main_page_info .main_page_user_tool_bar_text span').text(data.data.cart_total);
                    }

                    if (data.data.cart_total != 0 && Number(data.data.cart_total.split(' ').join('')) > 0) {
                        $('.cart_header .total_info .price').show();
                    }

                    if ($('.js__append_mini_cart').length > 0 && typeof data.data.html_mini_cart != 'undefined') {
                        $('.js__append_mini_cart').empty().append(data.data.html_mini_cart);
                    }

                    if ($('.js__send_checkout').length > 0) {
                        $('.js__open_mini_cart span').empty().text(data.data.cart_quantity);
                        $('.js__update_quantity').empty().text(data.data.cart_quantity_text);
                        $('.js__update_total_sum').empty().text(data.data.cart_total);
                        $('.js__update_total_sum[data-total]').attr('data-total', data.data.cart_total.replace(/\s+/g, ''))

                        checkoutTools.updateTotalPrice();
                    }

                    if (data.data.cart_quantity_total == 0) {
                        $('.block_add_cart').addClass('hide');
                        $('.cart_empty.header_cart').removeClass('hide');
                    }

                    localStorage.removeItem(`${guidGood}_${idGood}`);
                }
            });
        }
    });

    function addGoodCart(dataGood) {
        $('.modal_wrap[data-modal=addCartGood]').remove();
        loaderForm('', 'start', 'block');

        if ('garanty_price' in dataGood) {
            var garantyPrice = dataGood['garanty_price'].split(' ').join('');
        } else {
            var garantyPrice = undefined;
        }

        $.post(request.addGoodCart, {
            "id": dataGood['id'],
            "guid": dataGood['guid'],
            "item_type": dataGood['itemType'],
            "quantity": dataGood['quantity'],
            "price_type_id": dataGood['type_price'],
            "garanty_price": garantyPrice,
            "lang": lang
        }, function (data) {
            if (data.status == 'ok') {
                if (data.html != "") {
                    loaderForm('', 'stop', 'block');
                    $('footer').after(data.html);

                    $('.js__tab_modal_related_goods').first().trigger('click');
                    if (data.html_сart) {
                        $('.js_cart_header').empty().append(data.html_сart);
                    } else {
                        $('.cart_header .total_info .count, .cart_model_checkout .total_info .count').text(data.data.cart_quantity);
                        $('.cart_header .total_info .price span, .cart_model_checkout .total_info .price span').text(data.data.cart_total);
                        $('.js__all_active').attr('data-type_active', data.data.cart_quantity == data.data.cart_quantity_total ? 'all' : 'not_all');
                        $('.js__all_active .js__all_good_to_cart').empty().text(data.data.cart_quantity_total);
                        $('.js__all_active .js__all_good_active_to_cart').empty().text(data.data.cart_quantity);
                    }

                    if ($('.js__send_checkout').length > 0) {
                        $('.js__open_mini_cart span').empty().text(data.data.cart_quantity);
                        $('.js__update_quantity').empty().text(data.data.cart_quantity_text);
                        $('.js__update_total_sum').empty().text(data.data.cart_total);
                        $('.js__update_total_sum[data-total]').attr('data-total', data.data.cart_total.replace(/\s+/g, ''))

                        checkoutTools.updateTotalPrice();
                    }

                    if ($('.js__append_mini_cart').length > 0 && typeof data.data.html_mini_cart != 'undefined') {
                        $('.js__append_mini_cart').empty().append(data.data.html_mini_cart);
                    }

                    $('.js__quantity').text(data.data.cart_quantity);

                    if ($('.js__main_page_info').length > 0) {
                        $('.js__main_page_info .main_page_user_tool_bar_text span').text(data.data.cart_total);
                    }

                    if (data.data.cart_total != 0 && Number(data.data.cart_total.split(' ').join('')) > 0) {
                        $('.cart_header .total_info .price').show();
                    }

                    $('.modal_wrap[data-modal="addCartGood"] .submit_bue_click')
                        .attr({
                            'data-indexGtm': Number(dataGood.indexGtm),
                            'data-itemListNameGtm': dataGood.itemListNameGtm,
                        })

                    phoneMask();

                    let good_object = JSON.parse(localStorage.getItem(data.data.cart_id));
                    const spanGtm = $(`.js__info_gtm[data-guidCart=${data.data.cart_id}]`);

                    if (good_object) {
                        if (dataGood['quantity'] > 1) {
                            good_object[0].quantity = dataGood['quantity'];
                        } else {
                            good_object[0].quantity = 1;
                        }
                        good_object[1].quantity = $(`.modal_wrap[data-modal="addCartGood"] .js__count_input[data-idCart=${data.data.cart_id}]`).val();

                        dataLayer.push({
                            ecommerce: null
                        });
                        dataLayer.push({
                            event: "add_to_cart",
                            label: "main",
                            ecommerce: {
                                items: [good_object[0]]
                            }
                        });

                        localStorage.setItem(data.data.cart_id, JSON.stringify(good_object));
                    } else {
                        const dataGtm = [{
                            item_name: spanGtm.attr('data-itemName'),
                            item_id: spanGtm.attr('data-id'),
                            price: Number(spanGtm.attr('data-price')),
                            item_brand: spanGtm.attr('data-itemBrand') != "" ? spanGtm.attr('data-itemBrand') : null,
                            item_category: spanGtm.attr('data-cat3') != "" ? spanGtm.attr('data-cat3') : null,
                            item_category2: spanGtm.attr('data-cat2') != "" ? spanGtm.attr('data-cat2') : null,
                            item_category3: spanGtm.attr('data-cat1') != "" ? spanGtm.attr('data-cat1') : null,
                            item_category4: spanGtm.attr('data-cat4') != "" ? spanGtm.attr('data-cat4') : null,
                            item_variant: spanGtm.attr('data-itemVariant'),
                            item_list_name: dataGood.itemListNameGtm, // Передаємо назву списку, в якому знаходився товар (Див. нижче)
                            index: Number(dataGood.indexGtm),
                            quantity: Number(dataGood['quantity']),
                        }, { quantity: Number(dataGood['quantity']) }];
                        dataLayer.push({
                            ecommerce: null
                        });
                        dataLayer.push({
                            event: "add_to_cart",
                            label: "main",
                            ecommerce: {
                                items: [dataGtm[0]]
                            }
                        });

                        localStorage.setItem(data.data.cart_id, JSON.stringify(dataGtm));
                    }

                    if ($('.modal_wrap[data-modal="addCartGood"] .js__garanty_check').length > 0) {
                        const garantySpan = $('.modal_wrap[data-modal="addCartGood"] .js__info_garanty_gtm');
                        let good_object = JSON.parse(localStorage.getItem(`${garantySpan.attr('data-guidCart')}_${garantySpan.attr('data-id')}`));

                        if (good_object) {
                            if (dataGood['quantity'] > 1) {
                                good_object[0].quantity = dataGood['quantity'];
                            } else {
                                good_object[0].quantity = 1;
                            }
                            good_object[1].quantity = $(`.modal_wrap[data-modal="addCartGood"] .js__count_input[data-idCart=${data.data.cart_id}]`).val();

                            dataLayer.push({
                                ecommerce: null
                            });
                            dataLayer.push({
                                event: "add_to_cart",
                                label: "main",
                                ecommerce: {
                                    items: [good_object[0]]
                                }
                            });
                            localStorage.setItem(`${garantySpan.attr('data-guidCart')}_${garantySpan.attr('data-id')}`, JSON.stringify(good_object));
                        } else {
                            const dataGtm = [{
                                item_name: garantySpan.attr('data-itemName'),
                                item_id: garantySpan.attr('data-id'),
                                price: Number(garantySpan.attr('data-price').split(' ').join('')),
                                item_brand: null,
                                item_category: garantySpan.attr('data-cat3') != "" ? garantySpan.attr('data-cat3') : null,
                                item_category2: garantySpan.attr('data-cat2') != "" ? garantySpan.attr('data-cat2') : null,
                                item_category3: garantySpan.attr('data-cat1') != "" ? garantySpan.attr('data-cat1') : null,
                                item_category4: garantySpan.attr('data-cat4') != "" ? garantySpan.attr('data-cat4') : null,
                                item_variant: garantySpan.attr('data-itemVariant'),
                                item_list_name: dataGood.itemListNameGtm,
                                index: '1',
                                quantity: Number(dataGood['quantity']),
                            }, { quantity: Number(dataGood['quantity']) }];
                            dataLayer.push({
                                ecommerce: null
                            });
                            dataLayer.push({
                                event: "add_to_cart",
                                label: "main",
                                ecommerce: {
                                    items: [dataGtm[0]]
                                }
                            });

                            localStorage.setItem(`${garantySpan.attr('data-guidCart')}_${garantySpan.attr('data-id')}`, JSON.stringify(dataGtm));
                        }
                    }
                }
            }
        });
    }

    $(document).on('click', '.js__tab_modal_related_goods', function () {
        $('.js__tab_modal_related_goods').removeClass('active');
        $('.js__related_goods_modal').removeClass('open');
        const btn = $(this);
        const name = btn.data('tab');

        btn.addClass('active');

        if (name == 'all') {
            $(`.js__related_goods_modal`).addClass('open');
        } else {
            $(`.js__related_goods_modal[data-tab=${name}]`).addClass('open');
        }

        alignmentTileGlobalModal();
    });

    function alignmentTileGlobalModal() {
        $('.js__modal_related_goods .tile_title .tile_link').css('min-height', ``);
        $('.js__modal_related_goods .wrap_price').css('min-height', ``);
        $('.js__modal_related_goods .js__non_buy_button button').css('min-height', ``);
        $('.js__modal_related_goods .tile_availability .js__temp').css('min-height', ``);
        $('.js__modal_related_goods .tile_article').css('min-height', ``);


        let row_length = 1;
        if (window.innerWidth >= 650 && window.innerWidth <= 992) {
            row_length = 2
        } else if (window.innerWidth > 992) {
            row_length = 3
        }

        $('.js__modal_related_goods').each(function () {
            let rows_title = {};
            let rows_prise = {};
            let rows_button = {};
            let rows_temp = {};
            let rows_tile_article = {}
            let counter = 0;


            $(this).find('.tile_element').each(function (i) {
                const nameTile = $(this).find('.tile_title .tile_link');
                const priceTile = $(this).find('.tile_button .wrap_price');
                const oneBuyClick = $(this).find('.tile_button .buy_one_click_good');
                const temp = $(this).find('.tile_availability .js__temp');
                const tileArticle = $(this).find('.tile_article');

                if (rows_title[counter]) {
                    rows_title[counter] = [...rows_title[counter], nameTile.height()];
                } else {
                    rows_title[counter] = [nameTile.height()];
                }

                if (rows_temp[counter]) {
                    rows_temp[counter] = [...rows_temp[counter], temp.length == 0 ? 0 : temp.height()];
                } else {
                    rows_temp[counter] = [temp.length == 0 ? 0 : temp.height()];
                }

                if (rows_prise[counter]) {
                    rows_prise[counter] = [...rows_prise[counter], priceTile.outerHeight()];
                } else {
                    rows_prise[counter] = [priceTile.outerHeight()];
                }

                if (rows_tile_article[counter]) {
                    rows_tile_article[counter] = [...rows_tile_article[counter], tileArticle.outerHeight()];
                } else {
                    rows_tile_article[counter] = [tileArticle.outerHeight()];
                }

                if (rows_button[counter]) {
                    rows_button[counter] = [...rows_button[counter], (typeof oneBuyClick.outerHeight(
                        true)) == 'number' ? oneBuyClick.outerHeight(true) : 0];
                } else {
                    rows_button[counter] = [(typeof oneBuyClick.outerHeight(true)) == 'number' ?
                        oneBuyClick.outerHeight(true) : 0
                    ];
                }

                if ((i + 1) % row_length === 0) {
                    counter++;
                }
            })

            $(this).find('.tile_element').each(function (i) {
                const row_number = Math.floor(i / row_length);
                const row_title = rows_title[row_number].sort((a, b) => { return a - b }).reverse();
                const row_prise = rows_prise[row_number].sort((a, b) => { return a - b }).reverse();
                const row_button = rows_button[row_number].sort((a, b) => { return a - b }).reverse();
                const row_temp = rows_temp[row_number].sort((a, b) => { return a - b }).reverse();
                const row_tile_article = rows_tile_article[row_number].sort((a, b) => { return a - b }).reverse();


                $(this).find('.tile_title .tile_link').css('min-height', `${row_title[0]}px`);
                $(this).find('.js__non_buy_button button').css('margin-bottom', `${row_button[0]}px`);
                $(this).find('.wrap_price').css('min-height', `${row_prise[0]}px`);
                $(this).find('.tile_availability .js__temp').css('min-height', `${row_temp[0]}px`);
                $(this).find('.tile_article').css('min-height', `${row_tile_article[0]}px`);
            })
        });
    }

    $(window).resize(function () {
        alignmentTileGlobalModal();
    })
});

